import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Spinner, Stack, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ShimmerTable } from "react-shimmer-effects";
import { useLocation } from "react-router-dom";
import Main from '../layout/Main';
import fuziElevatorsApi from "../../api/fuziElevatorsApi"
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import { BrowserView } from "react-device-detect";
import InfoPill from "../InfoPill";
import { ROUTES } from "../../constants/webRouting";
import PERMISSIONS from "../../constants/permissions";
import { getUserDetails } from "../../utils/helper";

// import authApi from "../api/authApi";

const UserList = () => {
  const userInfo = getUserDetails();
  // const location = useLocation();
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  // const [leadname, setLeadName] = useState();
  // const[contact,setContact] = useState(location.state ? location.state : {});
  const [lead, setLead] = useState();
  ////console.log('location.state ='+location.state)

  useEffect(() => {

    async function init() {
      const users = await fuziElevatorsApi.fetchUsersForListPage();
      console.log('users', users);

      setBody(users);
      if (users) {
        //console.log("user data =>", users);
        setLead(users);
      } else {
        setBody([]);
        setLead([]);
      }
    }
    init();
  }, []);



  // const onFilterType = (event) => {
  //   if (event.target.value === "") {
  //     setBody(lead);
  //   } else {
  //     setBody(
  //       lead.filter((data) => {
  //         if (
  //           (data.leadstatus || "").toLowerCase() ===
  //           (event.target.value || "").toLowerCase()
  //         ) {
  //           return data;
  //         }
  //       })
  //     );
  //   }
  // };


  const editUser = (row) => {
    //console.log("row", row);
    navigate(`/users/${row.row.id}/e`, { state: row.row });
  }
  // Create table headers consisting of 4 columns.
  const header = [
    {
      title: "Name",
      prop: "username",
      isFilterable: true,
      cell: (row) => (
        <Link to={"/users/" + row.id} state={row}>
          {row.username}
        </Link>
      ),
      isSortable: true,
    },
    {
      title: "User Type",
      prop: "userrole",
      isFilterable: true,
      cell: (user) => getUserRoleDisplayName(user.userrole)
    },
    {
      title: "User Role",
      prop: "role_name",
      isFilterable: true,
    },
    { title: "Phone", prop: "phone", isFilterable: true },
    { title: "Email", prop: "email", isFilterable: true },
    {
      title: "Manager",
      prop: "managername",
      isFilterable: true,
      cell: (row) => (
        <Link to={`${ROUTES.USER.LIST}/${row?.managerid}`} state={row}>
          {row?.managername}
        </Link>
      ),
    },
    {
      title: "Active", prop: "isactive", isFilterable: true,
      cell: (row) => (

        row.isactive === true ? <i className="fa-regular fa-square-check" style={{ fontSize: "1.3rem", marginLeft: "19px" }}></i> : <i className="fa-regular fa-square" style={{ fontSize: "1.3rem", marginLeft: "19px" }}></i>

      )
    },
    {
      title: "Actions",
      prop: "id",
      cell: (row) => (
        [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_USER].some(permission => {
          return userInfo?.permissions.map(p => p.name).includes(permission);
        }) && (
          <Button
            size="sm"
            className="btn-custom"
            onClick={() => editUser({ row })}
          >
            <i className="fa-regular fa-pen-to-square "></i>
          </Button>
        )
      ),
    },

  ];

  const getUserRoleDisplayName = (role) => {
    switch (role) {
      // case "SUPER_ADMIN":
      //   return "SUPER ADMIN";
      // case "ADMIN":
      //   return "Office User";
      // case "USER":
      //   return "Factory User";
      default:
        return role;
    }
  };

  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

  const createUser = () => {
    navigate(`/users/e`);
  };

  // return (
  //   <Container fluid>
  //     <DatatableWrapper
  //       body={(body && Array.isArray(body)) ? body : []}
  //       headers={header}
  //       paginationOptionsProps={{
  //         initialState: {
  //           rowsPerPage: 20,
  //           options: [5, 10, 15, 20, 30],
  //         },
  //       }}
  //     >
  //       <Row className="align-items-end ">
  //         <Col
  //           className=""
  //         >
  //           <Filter classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }} />
  //         </Col>
  //         <Col
  //           md={1}
  //           className=""
  //         >
  //           <PaginationOptions labels={labels} />
  //         </Col>

  //         <Col  className="py-1">
  //               <BrowserView>
  //                 <div className="d-flex py-1 px-2 ">
  //                   <InfoPill left="Total" right={body?.length} rightClasses="bg-custom text-white border-white fw-bold" leftClasses="bg-white text-danger fw-bold " />
  //                 </div>
  //               </BrowserView>
  //             </Col>

  //         <Col
  //           xs={12}
  //           sm={6}
  //           lg={4}
  //           className="d-flex flex-col justify-content-end align-items-end"
  //         >
  //           <Stack direction="horizontal" gap={2}>
  //             <Button
  //               size="sm"
  //               className="btn-create"
  //               onClick={() => createUser(true)}
  //             >
  //               New User
  //             </Button>
  //           </Stack>
  //         </Col>
  //       </Row>

  //       <Table striped className="shadow rounded sm my-4" responsive={true}>
  //         <TableHeader classes={{ th: 'bg-custom text-white' }} />
  //         {
  //           (body && Array.isArray(body) ) ?
  //           <TableBody />
  //           :
  //           <tbody className="">
  //             <tr>
  //               <td colSpan={100} align="center">
  //                 <div>
  //                   <Spinner />
  //                 </div>
  //               </td>
  //             </tr>
  //           </tbody>
  //         }

  //       </Table>
  //       <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
  //     </DatatableWrapper>

  //     {/* <>
  //       <Helmet>{LIST_TAB_TITLE.ContactList}</Helmet>
  //     </> */}

  //     {/* <Row className="g-0">
  //       <Col lg={12} className="px-4">
  //         {body ? (
  //           <DatatableWrapper
  //             body={body}
  //             headers={header}
  //             paginationOptionsProps={{
  //               initialState: {
  //                 rowsPerPage: 20,
  //                 options: [5, 10, 15, 20, 30],
  //               },
  //             }}
  //           >
  //             <Row className="mb-4">
  //               <Col
  //                 xs={12}
  //                 lg={4}
  //                 className="d-flex flex-col justify-content-end align-items-end"
  //               >
  //                 <Filter/>
  //               </Col>
  //               <Col
  //                 xs={12}
  //                 sm={6}
  //                 lg={4}
  //                 className="d-flex flex-col justify-content-start align-items-start"
  //               >
  //                 <PaginationOptions labels={labels} />
  //                 <div style={{marginTop: "3px"}}>
  //                 <BrowserView>
  //                   <InfoPill left="Total" right={body?.length} />
  //                 </BrowserView>
  //                 </div>


  //               </Col>

  //               <Col
  //                 xs={12}
  //                 sm={6}
  //                 lg={4}
  //                 className="d-flex flex-col justify-content-end align-items-end"
  //               >
  //                 <Button className="btn-sm" style={{marginRight: "10px"}} variant="success" onClick={handleCopyLinkUrl}>Enquiry Form Url</Button>
  //                 <Button
  //                   className="btn-sm"
  //                   variant="outline-primary"
  //                   onClick={() => createContact(true)}
  //                 >
  //                   New Contact
  //                 </Button>
  //               </Col>
  //             </Row>
  //             <Table striped className="data-table" responsive="sm">
  //               <TableHeader />
  //               <TableBody />
  //             </Table>
  //             <Pagination />
  //           </DatatableWrapper>
  //         ) : (
  //           <ShimmerTable row={10} col={8} />
  //         )}
  //       </Col>
  //       <Col lg={2}></Col>
  //     </Row> */}
  //     {/* <Footer></Footer>  */}
  //   </Container>
  // );

  return (
    <Container fluid>
      <DatatableWrapper
        body={(body && Array.isArray(body)) ? body : []}
        headers={header}
        paginationOptionsProps={{
          initialState: {
            rowsPerPage: 50,
            options: [5, 10, 15, 20, 30, 50],
          },
        }}
      >
        <Row className="align-items-end ">
          <Col>
            <Filter classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }} />
          </Col>
          <Col
            md={1}
          >
            <PaginationOptions labels={labels} />
          </Col>

          <Col className="py-1">
            <BrowserView>
              <div className="d-flex py-1 px-2 ">
                <InfoPill left="Total" right={body?.length} rightClasses="bg-custom text-white border-white fw-bold" leftClasses="bg-white text-danger fw-bold " />
              </div>
            </BrowserView>
          </Col>
          <Col
            xs={12}
            sm={6}
            lg={4}
            className="d-flex flex-col justify-content-end align-items-end"
          >
            <Stack direction="horizontal" gap={2}>
              {[PERMISSIONS.MODIFY_ALL].some(permission => {
                return userInfo?.permissions.map(p => p.name).includes(permission);
              }) && (
                  <Button
                    size="sm"
                    className="btn-create"
                    onClick={() => createUser(true)}
                  >
                    New User
                  </Button>
                )}
            </Stack>
          </Col>
        </Row>

        <div className="table-scroll my-3">
          <Table striped className="shadow rounded sm my-4">
            <TableHeader classes={{ th: 'bg-custom text-white sticky-header' }} />
            {
              (body && Array.isArray(body)) ?
                <TableBody />
                :
                <tbody className="">
                  <tr>
                    <td colSpan={100} align="center">
                      <div>
                        <Spinner />
                      </div>
                    </td>
                  </tr>
                </tbody>
            }
          </Table>
        </div>
        {/* <div className="table-scroll">
    <Table striped className="shadow rounded sm my-4">
      <TableHeader classes={{ th: "sticky-header" }} />
      {
        (body && Array.isArray(body)) ?
          <TableBody />
          :
          <tbody>
            <tr>
              <td colSpan={100} align="center">
                <Spinner />
              </td>
            </tr>
          </tbody>
      }
    </Table>
  </div> */}

        <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
      </DatatableWrapper>
    </Container>
  );
}
  ;
export default UserList;
